import CompanyTermsTable from "../../components/terms/CompanyTermsTable";

interface CompanyTermsProps {
    searchTerm?: string;
}

export default function CompanyTerms({ searchTerm = "" }: CompanyTermsProps) {
    return (
        <>
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <CompanyTermsTable searchTerm={searchTerm} />
                </div>
            </div>
        </>
    );
}
